export default "__VITE_ASSET__CeQZlQhl__"